if (!customElements.get('scent-finder')) {
  customElements.define('scent-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const configNode = this.querySelector('[data-scent-config]');
      if (!configNode) return;

      const { looks, products } = JSON.parse(configNode.textContent);
      const questions = [
        { title: 'Which fragrance families captivate you?', description: 'Choose all that feel instinctively yours.', multiple: true, options: [['Floral','floral'],['Woody','woody'],['Citrus','citrus'],['Spice & Amber','spice'],['Gourmand','gourmand'],['Fresh','fresh']] },
        { title: 'Which natural notes draw you in?', description: 'Trust the material you want to move closer to.', options: [['Fresh & Green','fresh'],['Warm & Woody','woody'],['Bright & Floral','floral'],['Earthy & Resinous','spice']] },
        { title: 'Which world feels most like you?', description: 'Choose the atmosphere you would happily live inside.', options: [['Classic & Timeless','musk'],['Modern Minimalist','fresh'],['Bold & Daring','fruity'],['Bohemian & Natural','woody'],['Elegant & Sophisticated','spice']] },
        { title: 'When will this scent become yours?', description: 'Imagine the light, the pace and the people around you.', options: [['Everyday','floral'],['Office','fresh'],['Weekend','citrus'],['After Dark','spice'],['Far Away','woody']] },
        { title: 'How should your fragrance enter a room?', description: 'Watch how far the scent travels.', projection: true, options: [['Close','musk',{scale:.46,opacity:.18}],['Present','floral',{scale:.78,opacity:.42}],['Unforgettable','spice',{scale:1.18,opacity:.72}]] },
        { title: 'Where should this scent take you?', description: 'Choose a feeling, then add a memory if one appears.', memory: true, options: [['Somewhere Quiet','musk'],['After Dark','spice'],['Far Away','woody'],['Close to Someone','floral']] }
      ];

      const $ = (selector) => this.querySelector(selector);
      const media = $('[data-media]');
      const quiz = $('[data-quiz]');
      const reveal = $('[data-reveal]');
      const thinking = $('[data-thinking]');
      const result = $('[data-result]');
      const title = $('[data-title]');
      const description = $('[data-description]');
      const choices = $('[data-choices]');
      const counter = $('[data-counter]');
      const back = $('[data-back]');
      const next = $('[data-continue]');
      const memory = $('[data-memory]');
      const memoryInput = $('[data-memory-input]');
      const words = $('[data-summary-words]');
      const images = new Map();
      let step = 0;
      let activeLook = 'woody';
      let answers = questions.map(() => []);
      let timer;

      Object.entries(looks).forEach(([id, look]) => {
        const image = document.createElement('img');
        image.className = 'sf-scene';
        image.src = look.image;
        image.alt = '';
        image.decoding = 'async';
        image.style.objectPosition = look.position;
        media.append(image);
        images.set(id, image);
      });

      const setLook = (id, projection) => {
        if (!looks[id]) return;
        const current = images.get(activeLook);
        const upcoming = images.get(id);
        if (current !== upcoming) {
          current?.classList.remove('is-active');
          current?.classList.add('is-departing');
          upcoming.classList.remove('is-departing');
          requestAnimationFrame(() => upcoming.classList.add('is-active'));
          window.setTimeout(() => current?.classList.remove('is-departing'), 900);
        } else {
          upcoming.classList.add('is-active');
        }
        activeLook = id;
        this.style.setProperty('--accent', looks[id].accent);
        this.classList.toggle('is-projection', Boolean(projection));
        if (projection) {
          this.style.setProperty('--mist-scale', projection.scale);
          this.style.setProperty('--mist-opacity', projection.opacity);
        }
      };

      const render = (direction = 1) => {
        const question = questions[step];
        const saved = answers[step];
        quiz.classList.add('is-leaving');
        window.setTimeout(() => {
          title.textContent = question.title;
          description.textContent = question.description;
          counter.textContent = `${String(step + 1).padStart(2,'0')} / 06`;
          back.hidden = step === 0;
          next.textContent = step === 5 ? 'Reveal my scent →' : 'Continue →';
          memory.hidden = !question.memory;
          choices.replaceChildren();
          choices.style.setProperty('--count', Math.min(question.options.length, 6));
          choices.setAttribute('role', question.multiple ? 'group' : 'radiogroup');

          question.options.forEach(([label, lookId, projection], index) => {
            const selected = saved.some((answer) => answer.label === label);
            const button = document.createElement('button');
            button.className = `sf-choice${selected ? ' is-active' : ''}`;
            button.type = 'button';
            button.textContent = label;
            button.style.setProperty('--choice-glow', looks[lookId].glow);
            if (question.multiple) button.setAttribute('aria-pressed', String(selected));
            else {
              button.setAttribute('role', 'radio');
              button.setAttribute('aria-checked', String(selected));
            }
            button.addEventListener('click', () => select(index));
            choices.append(button);
          });

          next.disabled = saved.length === 0;
          const last = saved.at(-1);
          const fallback = question.options[0];
          setLook(last?.lookId || fallback[1], question.projection ? (last?.projection || fallback[2]) : null);
          quiz.style.transform = `translate3d(0,${direction * 18}px,0)`;
          requestAnimationFrame(() => {
            quiz.classList.remove('is-leaving');
            quiz.style.transform = '';
          });
        }, 430);
      };

      const select = (index) => {
        const question = questions[step];
        const [label, lookId, projection] = question.options[index];
        this.classList.add('is-interacted');
        if (question.multiple) {
          const found = answers[step].findIndex((answer) => answer.label === label);
          if (found >= 0) answers[step].splice(found, 1);
          else answers[step].push({ label, lookId, projection });
        } else {
          answers[step] = [{ label, lookId, projection }];
        }

        choices.querySelectorAll('.sf-choice').forEach((button, optionIndex) => {
          const selected = answers[step].some((answer) => answer.label === question.options[optionIndex][0]);
          button.classList.toggle('is-active', selected);
          button.setAttribute(question.multiple ? 'aria-pressed' : 'aria-checked', String(selected));
        });
        setLook(lookId, question.projection ? projection : null);
        next.disabled = answers[step].length === 0;
        if (!question.multiple && !question.memory) {
          window.clearTimeout(timer);
          timer = window.setTimeout(() => go(step + 1), 1150);
        }
      };

      const go = (target) => {
        if (target < 0 || target > questions.length) return;
        if (target === questions.length) {
          finish();
          return;
        }
        const direction = target > step ? 1 : -1;
        step = target;
        render(direction);
      };

      const finish = () => {
        quiz.classList.add('is-leaving');
        window.setTimeout(() => {
          quiz.hidden = true;
          reveal.hidden = false;
          thinking.hidden = false;
          result.hidden = true;
          this.classList.remove('is-projection');
          words.replaceChildren();
          answers.flat().slice(0,5).forEach((answer, index) => {
            const word = document.createElement('span');
            word.className = 'sf-summary-word';
            word.textContent = answer.label;
            word.style.animationDelay = `${index * 130}ms`;
            words.append(word);
          });
          window.setTimeout(showResult, 2150);
        }, 520);
      };

      const showResult = () => {
        const family = answers[0][0]?.lookId || 'woody';
        const match = products[family] || products.woody;
        thinking.hidden = true;
        result.hidden = false;
        $('[data-result-name]').textContent = match.name;
        $('[data-result-notes]').textContent = match.notes;
        const productImage = $('[data-result-image]');
        productImage.src = match.image;
        productImage.alt = match.name;
        this.querySelectorAll('[data-result-link]').forEach((link) => link.href = match.url);
        result.style.setProperty('--result-glow', match.glow);
        setLook(family);
      };

      const restart = () => {
        answers = questions.map(() => []);
        step = 0;
        memoryInput.value = '';
        reveal.hidden = true;
        quiz.hidden = false;
        quiz.classList.add('is-leaving');
        this.classList.remove('is-interacted');
        render(-1);
      };

      next.addEventListener('click', () => { if (!next.disabled) go(step + 1); });
      back.addEventListener('click', () => go(step - 1));
      $('[data-restart]').addEventListener('click', restart);
      this.addEventListener('pointermove', (event) => {
        const bounds = this.getBoundingClientRect();
        this.style.setProperty('--px', (((event.clientX - bounds.left) / bounds.width - .5) * 2).toFixed(3));
        this.style.setProperty('--py', (((event.clientY - bounds.top) / bounds.height - .5) * 2).toFixed(3));
      }, { passive: true });
      this.addEventListener('pointerleave', () => {
        this.style.setProperty('--px', 0);
        this.style.setProperty('--py', 0);
      });

      setLook('woody');
      render();
    }
  });
}
